import { Component, Input } from '@angular/core';

@Component({
    selector: 'additional-infos',
    template: `
    <div *ngIf="list" class="additional-informations">
        <span *ngFor="let additionalInfo of list; let last = last">
            {{ additionalInfo }} <ng-container *ngIf="!last">-</ng-container>
        </span>
    </div>

    `,
    styles: [`
    div {
        font-weight: initial;
        font-size: .8rem;
        color: #666;
    }

    :host{
        display: block;
    }

    `]
})
export class AdditionalInfosComponent {
    @Input()
    public list: string[];
}
